import classNames from 'classnames'
import { FieldError } from 'react-hook-form'

interface IProps {
  errors?: FieldError
  classes?: string
  hideWhenNotInError?: boolean
}

export const FieldErrorMessage: React.FC<IProps> = ({ errors, classes, hideWhenNotInError }) => {
  if (hideWhenNotInError && !errors) {
    return null
  }

  return <p className={classNames(classes, 'pl-2 pt-2 text-error text-xs')}>{errors?.message}</p>
}
